import { signal } from '@preact/signals';
import { isSelected } from './selection';

export interface XpDrop {
  readonly id: number;
  readonly pawnNetworkId: number;
  readonly skillId: string;
  readonly xpGained: number;
  readonly leveledUp: boolean;
  readonly createdAt: number;
}

const DROP_LIFETIME_MS = 1600;
const MAX_VISIBLE_DROPS = 8;

let nextDropId = 1;

export const xpDrops = signal<ReadonlyArray<XpDrop>>([]);

export const addXpDrop = ({
  pawnNetworkId,
  skillId,
  xpGained,
  leveledUp,
}: {
  pawnNetworkId: number;
  skillId: string;
  xpGained: number;
  leveledUp: boolean;
}): void => {
  if (xpGained <= 0) {
    return;
  }

  if (!isSelected({ networkId: pawnNetworkId })) {
    return;
  }

  const nextDrop: XpDrop = {
    id: nextDropId,
    pawnNetworkId,
    skillId,
    xpGained,
    leveledUp,
    createdAt: performance.now(),
  };
  nextDropId += 1;

  xpDrops.value = [nextDrop, ...xpDrops.value].slice(0, MAX_VISIBLE_DROPS);
};

export const pruneExpiredXpDrops = (): void => {
  const now = performance.now();
  const activeDrops = xpDrops.value.filter((drop) => now - drop.createdAt <= DROP_LIFETIME_MS);
  if (activeDrops.length !== xpDrops.value.length) {
    xpDrops.value = activeDrops;
  }
};

export const clearXpDrops = (): void => {
  xpDrops.value = [];
};
